import { RealEstate } from '../../../@types/real-estate-api-types'
import { DispatchType } from '../../../@types/redux-types'
import { InitState } from '../../reducers/root/initialState'
import {
  discardAISuggestionRequest,
  loadAISuggestionError,
  loadAISuggestionSuccess,
  startAISuggestionRequest,
} from '../../reducers/suggestedText/suggestedTextFeature'
import { generateSuggestionFromGenAi } from '../../../api/generateSuggestion/generateAISuggestionApi'
import { v4 as uuid } from 'uuid'
import { getAiTextLogContext, getSuggestionSummary, logAiTextInvestigation } from './suggestedTextLogging'

export const loadSuggestedTextsFromGenAi =
  (realEstate: RealEstate) => async (dispatch: DispatchType, getState: () => InitState) => {
    const { isTitleManuallyEdited, isDescriptionManuallyEdited, isLocationManuallyEdited } =
      getState().suggestedTextFeature
    if (isLocationManuallyEdited || isTitleManuallyEdited || isDescriptionManuallyEdited) {
      logAiTextInvestigation('request_skipped_manual_flags', getAiTextLogContext(getState()))
      return
    }

    const requestId = uuid()
    const sourceVersion = getState().insertionFeature.changeVersion

    dispatch(startAISuggestionRequest({ requestId, sourceVersion }))
    logAiTextInvestigation('request_started', {
      requestId,
      sourceVersion,
      ...getAiTextLogContext(getState()),
    })

    try {
      const suggestions = await generateSuggestionFromGenAi(realEstate, requestId)
      const state = getState()

      if (state.suggestedTextFeature.activeRequestId !== requestId) {
        logAiTextInvestigation('response_ignored_stale', {
          requestId,
          sourceVersion,
          ...getSuggestionSummary(suggestions),
          ...getAiTextLogContext(state),
        })
        return
      }

      if (
        state.suggestedTextFeature.isTitleManuallyEdited ||
        state.suggestedTextFeature.isDescriptionManuallyEdited ||
        state.suggestedTextFeature.isLocationManuallyEdited
      ) {
        dispatch(discardAISuggestionRequest({ requestId }))
        logAiTextInvestigation('response_discarded_manual_flags', {
          requestId,
          sourceVersion,
          ...getSuggestionSummary(suggestions),
          ...getAiTextLogContext(getState()),
        })
        return
      }

      dispatch(loadAISuggestionSuccess({ requestId, suggestions }))
      logAiTextInvestigation('response_applied_to_store', {
        requestId,
        sourceVersion,
        ...getSuggestionSummary(suggestions),
        ...getAiTextLogContext(getState()),
      })
    } catch (error) {
      if (getState().suggestedTextFeature.activeRequestId !== requestId) {
        logAiTextInvestigation('response_error_ignored_stale', {
          requestId,
          sourceVersion,
          errorMessage: error instanceof Error ? error.message : 'unknown',
          ...getAiTextLogContext(getState()),
        })
        return
      }

      dispatch(loadAISuggestionError({ requestId }))
      logAiTextInvestigation('response_failed', {
        requestId,
        sourceVersion,
        errorMessage: error instanceof Error ? error.message : 'unknown',
        ...getAiTextLogContext(getState()),
      })
    }
  }
